import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableBoolean, nullableNumber, nullableString } from '../utils/wire-value-utils';
import { DroneOwnership } from './drone-ownership.model';

/**
 * A document attached to a drone: registration papers, insurance, manuals, maintenance records.
 * Mirrors the hub's `DroneResource` (`/drones/:droneId/resources`).
 *
 * `adminOnly` rows are filtered out server-side, so everything reaching here is shared with the operator.
 * Fields the hub didn't send stay `undefined` (an explicit `null` stays `null`).
 */
export class DroneResource extends Base {
  // Set on upload
  resourceType?: string | null;
  caption?: string | null;
  fileName?: string | null;
  fileSize?: number | null;
  fileType?: string | null;
  fileExtension?: string | null;
  s3Key?: string | null;
  cdnUrl?: string | null;

  // Read-only fields
  droneId?: string | null;
  droneSource?: DroneOwnership | null;
  adminOnly?: boolean | null;
  uploadedByProfileId?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.resourceType = nullableString(source['resourceType']);
    this.caption = nullableString(source['caption']);
    this.fileName = nullableString(source['fileName']);
    this.fileSize = nullableNumber(source['fileSize']);
    this.fileType = nullableString(source['fileType']);
    this.fileExtension = nullableString(source['fileExtension']);
    this.s3Key = nullableString(source['s3Key']);
    this.cdnUrl = nullableString(source['cdnUrl']);
    this.droneId = nullableString(source['droneId']);
    this.droneSource = nullableString(source['droneSource']) as DroneOwnership | null | undefined;
    this.adminOnly = nullableBoolean(source['adminOnly']);
    this.uploadedByProfileId = nullableString(source['uploadedByProfileId']);
  }
}
